import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent"
import FilterInTable from "../../../../../Manage/FilterInTable"
import styles from "./Pending.module.scss"

const Pending = () => {
  const data = [
    {
      id: "#235435747",
      invoice: "Invoice",
      items: "200",
      orderDate: "20/06/2024",
      updateDate: "Pending since 1 hour",
      price: "$71.98",
      paymentMethod: "Bank transfer",
      status: "Pending",
    },
    {
      id: "#235435746",
      invoice: "Invoice",
      items: "200",
      orderDate: "20/06/2024",
      updateDate: "Pending since 1 hour",
      price: "$71.98",
      paymentMethod: "Bank transfer",
      status: "Pending",
    },
    {
      id: "#235435744",
      invoice: "Invoice",
      items: "200",
      orderDate: "20/06/2024",
      updateDate: "27/09/24",
      price: "$71.98",
      paymentMethod: "Bank transfer",
      status: "Pending",
    },
  ]

  const columns = [
    { name: "Order ID", selector: (row) => row.id, minWidth: "120px" },
    { name: "Invoice", selector: (row) => row.invoice },
    { name: "Order date", selector: (row) => row.orderDate, minWidth: "140px" },
    { name: "Update date", selector: (row) => row.updateDate, minWidth: "140px" },
    { name: "Price", selector: (row) => row.price },
    { name: "Payment method", selector: (row) => row.paymentMethod, minWidth: "160px" },
    { name: "Status", selector: (row) => row.status },
    { name: "Action", cell: () => <span className="cursor-pointer">Cancel</span> },
  ]

  return (
    <div>
      <div className="my-3">
        <span className={styles.info}>Total Orders: 300</span>
      </div>
      <div className="bg-white p-2 d-flex flex-column gap-2">
        <FilterInTable componentName="Packaging Material Order" />
        <DatatableComponent columns={columns} data={data} type={"gray"} pagination />
      </div>
    </div>
  )
}

export default Pending
